import * as React from 'react';
import { SVGProps } from 'react';

const SvgChip = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 18 6 6h12v12z" />
  </svg>
);

export default SvgChip;
